import { render } from "./GeneralManagersManagement.vue?vue&type=template&id=6400feaa&scoped=true"
import script from "./GeneralManagersManagement.vue?vue&type=script&lang=js"
export * from "./GeneralManagersManagement.vue?vue&type=script&lang=js"

import "./GeneralManagersManagement.vue?vue&type=style&index=0&id=6400feaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6400feaa"]])

export default __exports__